// src/components/atomic-crm/activities/ActivityCreateButton.tsx
import { useState } from "react";
import { Plus } from "lucide-react";
import { useTranslate } from "ra-core";
import { Button } from "@/components/ds/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ds/ui/dialog";
import { ActivityComposer } from "./ActivityComposer";

export const ActivityCreateButton = () => {
  const [open, setOpen] = useState(false);
  const translate = useTranslate();

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        {/* 👈 Matched exactly to the standard CreateButton styling */}
        <Button
          variant="outline"
          className="bg-white text-black hover:bg-gray-100 font-normal" // 👈 added font-normal
        >
          <Plus className="mr-2 h-4 w-4" />
          {translate("crm.action.new_activity", { _: "Activity" })}
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px] p-0 border-none bg-transparent shadow-none">
        <DialogHeader className="sr-only">
          <DialogTitle>Activity</DialogTitle>
        </DialogHeader>
        <ActivityComposer showPicker />
      </DialogContent>
    </Dialog>
  );
};
